<template>
    <div class="title-project-zone">
        <div v-if="embed" class="logo-iframe">
                    <img
                    src="@/assets/images/logo_eduloc360.png"
                    alt="eduloc360"
                    width="120"
                    height="50"
                />
                </div>
        <span ref="title" class="is-size-4 titleZone" @click="$emit('information')" :class="{'is-clickable':!isViewMode}">{{ getTitle }}</span>
        <button class="button is-ghost mt-1" @click="$emit('information')" v-if="!isViewMode">
            <span class="icon">
                <i class="mdi mdi-28px mdi-information-outline"></i>
            </span>
        </button>
        <a :href="viewRoute" target="_blank" class="button is-ghost mt-1"  v-if="isViewMode && isMobile">
            <span class="icon">
                <i class="mdi mdi-28px mdi-arrow-expand-all"></i>
            </span>
        </a>
    </div>
    <!--<nav class="project-navbar navbar has-shadow has-centered-menu" role="navigation" aria-label="main navigation">
        <div id="navbarBasicExample" class="navbar-menu">
            
            <div class="navbar-start" ref="leftZone"></div>

            <div ref="titleZone" class="navbar-item "> 
                <p ref="title" class="is-size-4 is-family-secondary titleZone">{{ project.title }}</p>
                <button class="button is-ghost" @click="$emit('information')">
                    <span class="icon is-medium">
                        <i class="mdi mdi-24px mdi-information-outline"></i>
                    </span>
                </button>
            </div>

            <div class="navbar-end" ref="rightZone"></div>

        </div>
        
    </nav>-->
</template>

<script>
export default {
    components: {
    },
    props: {
        content: {
            type: Object,
            default: () => {
                return {};
            },
        },
        isViewMode: {
            type: Boolean,
            default: false,
        },
        
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            titleWidth: 0,
            titleMaxWidth: 0,
            center: window.innerWidth/2,
            leftPadding: 0,
            embed: this.$route.meta.embed,
        };
    },
    computed: {
        project() {
            if(this.content && this.content.title){
                return this.content;
            }else{
                return this.$store.getters.project;
            }
            
        },
        windowSize() {
            return this.$mq;
        },
        isMobile(){
            return this.$mq=="mobile"
        },
        viewRoute(){
            return this.$route.path;
        },
        getTitle() {
            if (this.project.titlePerLang) {
                return this.project.titlePerLang[this.project.defaultLang]
            }
            return this.project.title
        }
    },
    created() {
        // window.addEventListener('resize', this.onResize);
    },
    mounted() {
        /*this.$nextTick(() => {
            setTimeout(() => {
                    this.onResize();
                }, 700);
        })*/
    },
    
    beforeDestroy() { 
        // window.removeEventListener('resize', this.onResize); 
    },
    /*methods: {  
        onResize() {
            this.windowWidth = window.innerWidth;

            // console.log("left",this.$refs.leftZone.clientWidth)
            // console.log("right",this.$refs.rightZone.clientWidth)

            this.titleWidth = this.$refs.title.clientWidth;

            // console.log("title",this.titleWidth)

            this.titleMaxWidth = this.windowWidth - this.$refs.leftZone.clientWidth - this.$refs.rightZone.clientWidth;

            // console.log("title max width",this.titleMaxWidth)

            this.$refs.titleZone.style.width = this.titleMaxWidth + "px";
            this.center = this.windowWidth/2;

            // console.log("center page",this.center)

            if(this.titleWidth<this.titleMaxWidth){
                const titleMiddle=this.titleWidth/2;
                this.leftPadding = this.center - this.$refs.leftZone.clientWidth - titleMiddle;
                // console.log("left padding",this.leftPadding)
                this.$refs.titleZone.style.paddingLeft=this.leftPadding+"px";
            }
        },
    }*/
};
</script>

<style scoped>
   
    .titleZone{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;    
        font-family: var(--primary-font);
        line-height: 2.4rem;
    }
    .title-project-zone{
        background-color: #014c6c;
        max-height: 2.5rem;
        min-height: 2.5rem;
        text-align: center;
        color: #FFFFFF;
    }
    .title-project-zone button,.title-project-zone button:hover{
        color: #FFFFFF;
        height: 2.1rem;
        margin-left: 1.2rem 
    }
    /*.title-project-zone span{
        line-height: 2rem;
    }
    .title-project-zone i{
        margin-bottom: 2px;
    }*/
    .mdi-28px.mdi-arrow-expand-all{
        font-size: 24px;
        color: #FFFFFF;
        padding: 0;
        margin: 0;
        margin-bottom: 8px;
    }
    
</style>
